<script lang="ts">
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { fa } from '../../../shared/i18n/fa';
  import { Card, ErrorState, LoadingState } from '../../../shared/ui';
  import { useBookingSettings } from '../../scheduling';
  import WorkingHoursForm from './WorkingHoursForm.svelte';

  /**
   * The clinic's working days and hours: the suggestion of the nearest free time looks only inside them.
   * `embedded` drops the card and title (the welcome tour has its own).
   */
  let { embedded = false, onSaved }: { embedded?: boolean; onSaved?: () => void } = $props();
  const org = useOrg();
  const settings = useBookingSettings(org.orgId);
</script>

{#snippet body()}
  <p class="mb-3 text-sm text-text-2">{fa.workingHours.hint}</p>
  {#if settings.isPending}
    <LoadingState />
  {:else if settings.isError}
    <ErrorState error={settings.error} onRetry={() => void settings.refetch()} />
  {:else}
    <WorkingHoursForm initial={settings.data.workingShifts} readOnly={!org.can('settings.manage')} {onSaved} />
  {/if}
{/snippet}

{#if embedded}
  {@render body()}
{:else}
  <Card data-tour="settings-hours">
    <h2 class="mb-2 font-bold">{fa.workingHours.title}</h2>
    {@render body()}
  </Card>
{/if}
